const appConfig = require("@/config.json");

// Strapi 3 generates resized formats (thumbnail / small / medium / large) for
// uploaded images and exposes them on the media object's `formats` field. This
// returns an absolute URL to the requested size, falling back to the next
// available size and finally the original upload — no external image service.
const SIZE_ORDER = ["thumbnail", "small", "medium", "large"];

const getImageURL = (image, size = "medium") => {
  if (!image) return "";

  const base = appConfig.api.base;
  const toAbsolute = (u) =>
    !u ? "" : /^https?:\/\//i.test(u) ? u : `${base}${u}`;

  const formats = image.formats || {};

  // Prefer the requested size, then larger sizes, then smaller ones.
  const start = SIZE_ORDER.indexOf(size);
  const order =
    start === -1
      ? SIZE_ORDER.slice()
      : SIZE_ORDER.slice(start).concat(SIZE_ORDER.slice(0, start).reverse());

  for (let i = 0; i < order.length; i++) {
    const fmt = formats[order[i]];
    if (fmt && fmt.url) return toAbsolute(fmt.url);
  }

  // No formats available (e.g. SVG or an image smaller than every format).
  return toAbsolute(image.url);
};

export { getImageURL };
